import script from "./ProjectCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCard.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCard.vue?vue&type=style&index=0&id=e4ecf8ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4ecf8ae"]])

export default __exports__